export default class CategoryController {
  constructor(ImagesDataProvider, $state) {
    "ngInject"
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.type = 1;
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getCategories();
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getCategories();
  }

  getCategories() {
    let
      vm = this;
    let data = [];
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.ImagesDataProvider.getCategory(data).then(function (result) {
      vm.categories = result.data;
      vm.categoriesTotal = result.total;
    });
  }

  removeCategory(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.ImagesDataProvider.removeCategory(id).then(function (res) {
      vm.getCategories();
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/components/category_listing/controller.js
 **/